import { usePostMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<typeof usePostMutation<z.ZodUndefined, z.ZodNull>>[3];

export const useConfirmAssessment = (id: number, config?: Config) => {
  return usePostMutation(
    z.undefined(),
    z.null(),
    `/console/assessment_progresses/${id}/confirm`,
    config,
  );
};
